export const RightTriangleIcon: React.VFC<{ className?: string }> = ({
  className,
}) => (
  <svg
    className={className}
    fill='none'
    viewBox='0 0 10 14'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='m8.6575 7.84711-6.16725 5.39549c-.72675.6368-1.86525.1193-1.86525-.8471v-10.79102c-.000185-.21627.061974-.42802.179034-.609875.117059-.181857.284056-.326117.480996-.415505.19694-.089387.41547-.120114.62942-.088499.21395.031614.41426.124229.57693.266755l6.16499 5.395504c.12084.10559.21769.23581.28404.38192.06636.14611.10069.30473.10069.4652s-.03433.31909-.10069.4652c-.06635.14611-.1632.27633-.28404.38193z'
      fill='currentColor'
    />
  </svg>
);
